export const USER_LOCAL_STORAGE_KEY = 'sessionUser';


// WEBPACK FOOTER //
// ./src/constants/localStorage.js